import { render } from "./AiPortalTab.vue?vue&type=template&id=3078eaaf&scoped=true&ts=true"
import script from "./AiPortalTab.vue?vue&type=script&lang=ts"
export * from "./AiPortalTab.vue?vue&type=script&lang=ts"

import "./AiPortalTab.vue?vue&type=style&index=0&id=3078eaaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3078eaaf"]])

export default __exports__